import {
    URLAPI,
    GENDER_PATH,
    GENDER_CREATE_PATH,
    GENDER_UPDATE_PATH,
    GENDER_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_gender: {
        data: [],
        status: 0,
        message: {},
    },
    _create_gender: {
        data: {},
        status: 0,
        message: {},
    },
    _update_gender: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_gender: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_GENDER_SUCCESS = "GET_ALL_GENDER_SUCCESS";
export const CREATE_GENDER = "CREATE_GENDER";
export const UPDATE_GENDER = "UPDATE_GENDER";
export const DELETE_GENDER = "DELETE_GENDER";

export const gender_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_GENDER_SUCCESS:
            return {
                ...state,
                _get_all_gender: action.payload,
            };
        case CREATE_GENDER:
            return {
                ...state,
                _create_gender: action.payload,
            };
        case UPDATE_GENDER:
            return {
                ...state,
                _update_gender: action.payload,
            };
        case DELETE_GENDER:
            return {
                ...state,
                _delete_gender: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};


export const get_all_gender = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${GENDER_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_GENDER_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_GENDER_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_GENDER_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Ocurrió un error",
                },
            });
        }
    }
}

export const create_gender = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${GENDER_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_GENDER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_GENDER,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_GENDER,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const update_gender = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${GENDER_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_GENDER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_GENDER,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_GENDER,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const delete_gender = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${GENDER_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_GENDER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_GENDER,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_GENDER,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_gender = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
